<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center">
					<v-col cols="3">
						<v-text-field
							outlined
							:append-icon="readonly['bussinessTel'] ? 'mode_edit' : 'done'"
							:readonly="readonly['bussinessTel']"
							label="Contact Number"
							:v-model="company.contact"
							:value="company.contact"
							@click:append="readonly['bussinessTel'] ? edit('bussinessTel') : finished('bussinessTel')"
						></v-text-field>
					</v-col>
					<v-col cols="5">
						<v-text-field
							outlined
							:append-icon="readonly['secondaryEmail'] ? 'mode_edit' : 'done'"
							:readonly="readonly['secondaryEmail']"
							label="Secondary Email"
							:v-model="company.email"
							:value="company.email"
							@click:append="readonly['secondaryEmail'] ? edit('secondaryEmail') : finished('secondaryEmail')"
						></v-text-field>
					</v-col>
					<v-col cols="5">
						<v-text-field
							outlined
							:append-icon="readonly['managerEmail'] ? 'mode_edit' : 'done'"
							:readonly="readonly['managerEmail']"
							label="Primary Manager Email"
							:v-model="company.managers[0].email"
							:value="company.managers[0].email"
							@click:append="readonly['managerEmail'] ? edit('managerEmail') : finished('managerEmail')"
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	name: 'AdminViewPracticeContactCard',
	components: {},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Contact Details',
		readonly: {
			secondaryemail: true,
			bussinessTel: true,
			managerEmail: true,
		},
	}),
	methods: {
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			this.readonly[key] = true;
			this.$forceUpdate();
		},
	},
};
</script>
